import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';
import { getAfcAnalysis } from '../../common/endpoints';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const fetchAfcAnalysis = createApi(
  getAfcAnalysis,
  'GET'
);

const afcAnalysisSlice = createSlice({
  name: 'afcAnalysis',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAfcAnalysis.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAfcAnalysis.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAfcAnalysis.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default afcAnalysisSlice.reducer;
